// Auto-generated industries data — DO NOT EDIT MANUALLY
// Barrel re-export. Industries are split across groups/group-1..5 to keep
// each section file under the 400-LOC ceiling (Hard Rule 8).

import type { Industry } from './types';
import { industriesGroup1 } from './groups/group-1';
import { industriesGroup2 } from './groups/group-2';
import { industriesGroup3 } from './groups/group-3';
import { industriesGroup4 } from './groups/group-4';
import { industriesGroup5 } from './groups/group-5';

export type {
  Industry,
  IndustryPainPoint,
  IndustryUseCase,
  IndustryFaq,
  IndustryStat,
  Vertical,
} from './types';

export const industries: Industry[] = [
  ...industriesGroup1,
  ...industriesGroup2,
  ...industriesGroup3,
  ...industriesGroup4,
  ...industriesGroup5,
];

export function getIndustryBySlug(slug: string): Industry | undefined {
  return industries.find((i) => i.slug === slug);
}

export function getAllIndustrySlugs(): string[] {
  return industries.map((i) => i.slug);
}

export {
  verticals,
  getVerticalBySlug,
  getAllVerticalSlugs,
} from './verticals';
